import AlertMessage from 'src/components/ui-components/AlertMessage';
import axios from '../../lib/axios';
import ConfigUserGroupType from './Types/ConfigUserGroup';

const API_URLS = {
  GET_CONFIG_USER_GROUP: `/ConfigUserGroups/GetConfigUserGroup`,
  GET_CONFIG_MENUS: `/ConfigMenus/GetConfigMenusForAppKey`,
  GET_CONFIG_MENUS_FOR_CONFIG_USER_GROUP: `/ConfigUserGroups/GetMenusForConfigUserGroup`,
  INSERT_UPDATE_CONFIG_MENUS_FOR_CONFIG_USER_GROUP: `/ConfigUserGroups/InsertUpdateConfigUserGroupMenuMapping`,
  INSERT_UPDATE_CONFIG_USER_GROUP: `/ConfigUserGroups/InsertUpdateConfigUserGroup`
};

export const getConfigUserGroupByKey = async (configUserGroupKey): Promise<any> => {
  const response = await axios.get<ConfigUserGroupType>(API_URLS.GET_CONFIG_USER_GROUP, {
    params: {
      configUserGroupKey
    }
  }
  );
  return response?.data[0] || {};
};

export const getConfigUserGroupsList = async (): Promise<any> => {
  const response = await axios.get<ConfigUserGroupType[]>(API_URLS.GET_CONFIG_USER_GROUP);
  return response?.data  || [];
};

export const getConfigMenusList = async (): Promise<any> => {
  const response = await axios.get(API_URLS.GET_CONFIG_MENUS);
  return response?.data  || [];
};

export const getConfigMenusForUserGroup = async (configUserGroupKey): Promise<any> => {
  const response = await axios.get(API_URLS.GET_CONFIG_MENUS_FOR_CONFIG_USER_GROUP,{
    params: {
      configUserGroupKey
    }
  });
  return response?.data  || [];
};

export const insertUpdateConfigUserGroupMenuMapping = async (values: any) => {
  try {
    const res = await axios.post(API_URLS.INSERT_UPDATE_CONFIG_MENUS_FOR_CONFIG_USER_GROUP, values);
    AlertMessage({ type: 'success', msg: res.data.message });
    return res.data.status === 200;
  } catch (err) {
    if (err?.response?.data?.errors) {
      Object.entries(err.response.data.errors).forEach(([, errMsg]: any) => {
        AlertMessage({ type: 'error', msg: errMsg.errorMessage });
      });
    } else {
      AlertMessage({ type: 'error', msg: err.title || 'An error occured'});
    }
    return false;
  }
};

export const insertUpdateConfigUserGroup = async (values) => {
  try
  {
    const res = await axios.post(API_URLS.INSERT_UPDATE_CONFIG_USER_GROUP, values);
    AlertMessage({ type: 'success', msg: res.data.message });
    return true;
  } catch(err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};